export const PaymentOrderSource = {
  WEB: 'WEB',
  APP_STORE: 'APP_STORE',
  PLAY_STORE: 'PLAY_STORE',
} as const;

export type PaymentOrderSource =
  (typeof PaymentOrderSource)[keyof typeof PaymentOrderSource];
